// Manual slider
import Swiper from '@src/components/swiper';
// This variation does not seams to be used anymore ...
// Check /prev/section/slider/stats
document.addEventListener("DOMContentLoaded", function(event) {
  new Swiper('.slider-manual .swiper-container', {
    initialSlide: 0,
    grabCursor: true,
    slidesPerView: 2.5,
    centeredSlides: true,
    spaceBetween: 100,
    simulateTouch: true,
    slideToClickedSlide: true,
    breakpoints: {
      1439: {
        slidesPerView: 2,
        spaceBetween: 50,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      },
      1100: {
        slidesPerView: 1.6,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      },
      950: {
        slidesPerView: 1.3,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      },
      767: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      }
    }
  });

  var OffsetSlider = undefined;
  // Automatic slider
  if(document.querySelector('.swiper-container .swiper-slide')) {
    OffsetSlider = function() {
      var offset = document.querySelector('.swiper-container .swiper-slide').offsetWidth
      return (offset / 2);
    }
  }

  new Swiper('.swiper-opacity', {
    slidesPerView: 3,
    slidesOffsetBefore: window.onresize = OffsetSlider,
    loop: true,
    spaceBetween: 24,
    centeredSlides: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    },
    // Somehow, it works better now without this line
    // breakpoints: {
    //   768: {
    //     slidesPerView: 'auto',
    //     centeredSlides: true,
    //     spaceBetween: 12,
    //     slidesOffsetBefore: 0
    //   }
    // },
    on: {
      init: function(){
        document.querySelector('.swiper-opacity').style.opacity = 1
      }
    }
  });
});
